/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	Input,
	Output,
	EventEmitter,
	OnDestroy,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Role, ProjectMember } from '@touchplan/common';
import { Subject, Observable } from 'rxjs';
import { map, takeUntil, take } from 'rxjs/operators';
import * as strings from '@touchplan/strings';

@Component({
	selector: 'role-changer',
	templateUrl: './role-changer.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.Default,
})
export class RoleChangerComponent implements OnInit, OnDestroy {
	@Input() public roleList$: Observable<Map<string, Role>>;
	@Input() public authedProjectMember$: Observable<ProjectMember>;
	@Input() public projectMember: any;
	@Input() public suppressWrite = false;
	@Input() public sortAlphabetically = true;
	@Output() public roleChanged: EventEmitter<any> = new EventEmitter();
	private destroy$ = new Subject<void>();
	public roleList: Role[] = [];
	public currentRole = new UntypedFormControl(null);
	public placeHolderRole = strings.CHANGE_ROLE_TO;

	constructor() {}

	public ngOnInit() {
		this.currentRole.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((role) => {
			if (role) {
				this.updateProjectMemberRole(role);
			}
		});

		this.roleList$ = this.roleList$.pipe(
			map((roles: Map<string, Role>) => {
				const newRoles = new Map<string, Role>();
				roles.forEach((role: Role, roleId: string) => {
					// If you're a general member and it is not among your roles, delete that role from shown roleList.
					if (
						this.projectMember.accessLevel === 'General' &&
						this.projectMember.secondaryRoles &&
						!this.projectMember.secondaryRoles[roleId]
					) {
						return;
					}
					newRoles.set(roleId, role);
				});
				return newRoles;
			})
		);

		this.authedProjectMember$.pipe(take(1), takeUntil(this.destroy$)).subscribe((authedProjectMember) => {
			if (authedProjectMember) {
				this.currentRole.setValue(authedProjectMember.view.role);
			}
		});
	}
	public stopPropagation(event) {
		event.stopPropagation();
	}

	public updateProjectMemberRole(newRole) {
		this.roleChanged.emit(newRole);
		if (!this.suppressWrite) {
			this.projectMember.$ref().update({ roleId: newRole.$id });
		}
	}

	public ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
